import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-services-description',
  templateUrl: './services-description.component.html',
  styleUrls: ['./services-description.component.scss'],
})
export class ServicesDescriptionComponent {

  @Input() user;
  @Input() config;
  @Input() descriptionMinHeight: string = '150px';
  searchPoiLandingList = ['bea','bia','kit','wavelength','darkfiber','noadarkfiber'];

  env = environment;

  constructor() {}

  showPoiSearchNote() {
    if (this.env && this.env.serviceSlug) {
      if (this.searchPoiLandingList.includes(this.env.serviceSlug)) {
          return true;
      } else return false;
    }
  }

}
